import script from "./about.vue?vue&type=script&lang=ts&setup=true"
export * from "./about.vue?vue&type=script&lang=ts&setup=true"

import "./about.vue?vue&type=style&index=0&id=72ae1e18&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72ae1e18"]])

export default __exports__